/**
 * SITES.TYPES
 * Workplace with associated risks
 */
import { PhysicalRisk } from "@/entities/physical-risk/model/physical-risk.types"
import getColor from "@/utils/get-color.utils"
import { v4 as uuid } from "uuid"

export const SITE_ENTITY = "site"
export const SITE_COLOR = "#606060"

export type SitePoint = { x: number; y: number }
type SitePolygon = SitePoint[] // Anneau plat (ancien format / zone simple)
export type SiteLine = SitePoint[]
export type SiteMultiLine = SiteLine[]

// Multi-polygone : permet trous + morceaux disjoints après découpe automatique
export type SiteRing = SitePoint[] // Un anneau (extérieur ou trou)
type SitePolygonWithHoles = SiteRing[] // [anneauExterieur, ...trous]
export type SiteMultiPolygon = SitePolygonWithHoles[] // Plusieurs polygones disjoints

// La géométrie est stockée sous forme simple ou multiple selon geometryType.
// Toujours normaliser via site-geometry.utils avant traitement.
export type SiteGeometryType = "polygon" | "line"
export type SiteGeometry = SitePolygon | SiteMultiPolygon | SiteLine | SiteMultiLine

export interface Site {
  id: string
  isCheck: boolean
  name: string
  MapId: string | null
  geometryType: SiteGeometryType
  geometry: SiteGeometry
  populationIds: string[]

  //Relations
  EstablishmentId: string | null //If null not active

  //Calculated
  cColor: string
  cRiskMax: PhysicalRisk | null // Highest risk directly assigned to this site
}

export const createEmptySite = (overrides?: Partial<Site>): Site => {
  const defaultSite: Site = {
    id: uuid(),
    isCheck: false,
    name: "",
    MapId: null,
    geometryType: "polygon",
    geometry: [],
    populationIds: [],

    //Relations
    EstablishmentId: null,

    //Calculated
    cColor: getColor("grey"),
    cRiskMax: null
  }

  return {
    ...defaultSite,
    ...overrides
  }
}
